module.exports = __webpack_public_path__ + "img/step_6.611a89fe.png";